// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../fragments/commonFragments.generated';
import { PageInfoFragmentDoc } from '../projects/ProjectsPage.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradePartnersMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TradePartnersMetadataQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name: string }>, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, cohorts: Array<{ __typename?: 'Cohort', id: string, name: string }> };

export type TradePartnersQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TradePartnerFilter>;
}>;


export type TradePartnersQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string, averageScore: number, isSweetheart: boolean, markets: Array<{ __typename?: 'Market', id: string, name: string }>, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string, leadTimes: Array<{ __typename?: 'TradeCategoryLeadTime', leadTimeInDays: number, market: { __typename?: 'Market', id: string }, tradeCategory: { __typename?: 'TradeCategory', id: string, name: string }, leadTimeFrequency: { __typename?: 'TimeFrequencyDetail', code: Types.TimeFrequency, name: string } }> }>, onboardingStatus: { __typename?: 'TradePartnerOnboardingStatusDetail', code: Types.TradePartnerOnboardingStatus, name: string } }> };

export type TradePartnersPageQueryVariables = Types.Exact<{
  filter: Types.TradePartnerFilter;
  page: Types.PageFilter;
}>;


export type TradePartnersPageQuery = { __typename?: 'Query', tradePartnersPage: { __typename?: 'TradePartnersPage', entities: Array<{ __typename?: 'TradePartner', id: string, name: string, averageScore: number, isSweetheart: boolean, markets: Array<{ __typename?: 'Market', id: string, name: string }>, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string, leadTimes: Array<{ __typename?: 'TradeCategoryLeadTime', leadTimeInDays: number, market: { __typename?: 'Market', id: string }, tradeCategory: { __typename?: 'TradeCategory', id: string, name: string }, leadTimeFrequency: { __typename?: 'TimeFrequencyDetail', code: Types.TimeFrequency, name: string } }> }>, onboardingStatus: { __typename?: 'TradePartnerOnboardingStatusDetail', code: Types.TradePartnerOnboardingStatus, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type TradePartnersPageTradePartnerFragment = { __typename?: 'TradePartner', id: string, name: string, averageScore: number, isSweetheart: boolean, markets: Array<{ __typename?: 'Market', id: string, name: string }>, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string, leadTimes: Array<{ __typename?: 'TradeCategoryLeadTime', leadTimeInDays: number, market: { __typename?: 'Market', id: string }, tradeCategory: { __typename?: 'TradeCategory', id: string, name: string }, leadTimeFrequency: { __typename?: 'TimeFrequencyDetail', code: Types.TimeFrequency, name: string } }> }>, onboardingStatus: { __typename?: 'TradePartnerOnboardingStatusDetail', code: Types.TradePartnerOnboardingStatus, name: string } };

export type TradePartnersPage_TradeCategoriesFragment = { __typename?: 'TradeCategory', id: string, name: string, leadTimes: Array<{ __typename?: 'TradeCategoryLeadTime', leadTimeInDays: number, market: { __typename?: 'Market', id: string }, tradeCategory: { __typename?: 'TradeCategory', id: string, name: string }, leadTimeFrequency: { __typename?: 'TimeFrequencyDetail', code: Types.TimeFrequency, name: string } }> };

export type TradePartnersPage_TradeCategoryLeadTimesLike_TradeCategoryLeadTimeDefault_Fragment = { __typename?: 'TradeCategoryLeadTimeDefault', leadTimeInDays: number, market: { __typename?: 'Market', id: string }, tradeCategory: { __typename?: 'TradeCategory', id: string, name: string }, leadTimeFrequency: { __typename?: 'TimeFrequencyDetail', code: Types.TimeFrequency, name: string } };

export type TradePartnersPage_TradeCategoryLeadTimesLike_TradeCategoryLeadTime_Fragment = { __typename?: 'TradeCategoryLeadTime', leadTimeInDays: number, market: { __typename?: 'Market', id: string }, tradeCategory: { __typename?: 'TradeCategory', id: string, name: string }, leadTimeFrequency: { __typename?: 'TimeFrequencyDetail', code: Types.TimeFrequency, name: string } };

export type TradePartnersPage_TradeCategoryLeadTimesLikeFragment = TradePartnersPage_TradeCategoryLeadTimesLike_TradeCategoryLeadTimeDefault_Fragment | TradePartnersPage_TradeCategoryLeadTimesLike_TradeCategoryLeadTime_Fragment;

export const TradePartnersPage_TradeCategoryLeadTimesLikeFragmentDoc = gql`
    fragment TradePartnersPage_TradeCategoryLeadTimesLike on TradeCategoryLeadTimeLike {
  leadTimeInDays
  market {
    id
  }
  tradeCategory {
    id
    name
  }
  leadTimeFrequency {
    code
    name
  }
}
    `;
export const TradePartnersPage_TradeCategoriesFragmentDoc = gql`
    fragment TradePartnersPage_TradeCategories on TradeCategory {
  id
  name
  leadTimes {
    ...TradePartnersPage_TradeCategoryLeadTimesLike
  }
}
    ${TradePartnersPage_TradeCategoryLeadTimesLikeFragmentDoc}`;
export const TradePartnersPageTradePartnerFragmentDoc = gql`
    fragment TradePartnersPageTradePartner on TradePartner {
  id
  name
  averageScore
  isSweetheart
  markets {
    id
    name
  }
  tradeCategories {
    ...TradePartnersPage_TradeCategories
  }
  onboardingStatus {
    code
    name
  }
}
    ${TradePartnersPage_TradeCategoriesFragmentDoc}`;
export const TradePartnersMetadataDocument = gql`
    query TradePartnersMetadata {
  markets {
    ...Named
  }
  tradeCategories {
    ...Named
  }
  developments {
    ...Named
  }
  cohorts {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useTradePartnersMetadataQuery__
 *
 * To run a query within a React component, call `useTradePartnersMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnersMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnersMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useTradePartnersMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TradePartnersMetadataQuery, TradePartnersMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnersMetadataQuery, TradePartnersMetadataQueryVariables>(TradePartnersMetadataDocument, options);
      }
export function useTradePartnersMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnersMetadataQuery, TradePartnersMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnersMetadataQuery, TradePartnersMetadataQueryVariables>(TradePartnersMetadataDocument, options);
        }
export function useTradePartnersMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnersMetadataQuery, TradePartnersMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradePartnersMetadataQuery, TradePartnersMetadataQueryVariables>(TradePartnersMetadataDocument, options);
        }
export type TradePartnersMetadataQueryHookResult = ReturnType<typeof useTradePartnersMetadataQuery>;
export type TradePartnersMetadataLazyQueryHookResult = ReturnType<typeof useTradePartnersMetadataLazyQuery>;
export type TradePartnersMetadataSuspenseQueryHookResult = ReturnType<typeof useTradePartnersMetadataSuspenseQuery>;
export type TradePartnersMetadataQueryResult = Apollo.QueryResult<TradePartnersMetadataQuery, TradePartnersMetadataQueryVariables>;
export const TradePartnersDocument = gql`
    query TradePartners($filter: TradePartnerFilter) {
  tradePartners(filter: $filter) {
    ...TradePartnersPageTradePartner
  }
}
    ${TradePartnersPageTradePartnerFragmentDoc}`;

/**
 * __useTradePartnersQuery__
 *
 * To run a query within a React component, call `useTradePartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTradePartnersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TradePartnersQuery, TradePartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnersQuery, TradePartnersQueryVariables>(TradePartnersDocument, options);
      }
export function useTradePartnersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnersQuery, TradePartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnersQuery, TradePartnersQueryVariables>(TradePartnersDocument, options);
        }
export function useTradePartnersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnersQuery, TradePartnersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradePartnersQuery, TradePartnersQueryVariables>(TradePartnersDocument, options);
        }
export type TradePartnersQueryHookResult = ReturnType<typeof useTradePartnersQuery>;
export type TradePartnersLazyQueryHookResult = ReturnType<typeof useTradePartnersLazyQuery>;
export type TradePartnersSuspenseQueryHookResult = ReturnType<typeof useTradePartnersSuspenseQuery>;
export type TradePartnersQueryResult = Apollo.QueryResult<TradePartnersQuery, TradePartnersQueryVariables>;
export const TradePartnersPageDocument = gql`
    query TradePartnersPage($filter: TradePartnerFilter!, $page: PageFilter!) {
  tradePartnersPage(filter: $filter, page: $page) {
    entities {
      ...TradePartnersPageTradePartner
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${TradePartnersPageTradePartnerFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useTradePartnersPageQuery__
 *
 * To run a query within a React component, call `useTradePartnersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnersPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTradePartnersPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradePartnersPageQuery, TradePartnersPageQueryVariables> & ({ variables: TradePartnersPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnersPageQuery, TradePartnersPageQueryVariables>(TradePartnersPageDocument, options);
      }
export function useTradePartnersPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnersPageQuery, TradePartnersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnersPageQuery, TradePartnersPageQueryVariables>(TradePartnersPageDocument, options);
        }
export function useTradePartnersPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnersPageQuery, TradePartnersPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradePartnersPageQuery, TradePartnersPageQueryVariables>(TradePartnersPageDocument, options);
        }
export type TradePartnersPageQueryHookResult = ReturnType<typeof useTradePartnersPageQuery>;
export type TradePartnersPageLazyQueryHookResult = ReturnType<typeof useTradePartnersPageLazyQuery>;
export type TradePartnersPageSuspenseQueryHookResult = ReturnType<typeof useTradePartnersPageSuspenseQuery>;
export type TradePartnersPageQueryResult = Apollo.QueryResult<TradePartnersPageQuery, TradePartnersPageQueryVariables>;